import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm, LabelCabecera, LabelNota } from '../../componentes/componentes_generales/componentes_formulario/labels/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import global_axios from '../../funciones_globales/interaccionapi';
import { completar_String } from '../../funciones_globales/format';
import styled from 'styled-components';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { cargarCatalogoEstados, cargarCatalogos_Otros }from '../../funciones_globales/catalogos';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import SelectArticulo from '../inventario/selectArticulo';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import '@trendmicro/react-toggle-switch/dist/react-toggle-switch.css';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import moment from 'moment';
import { formatearFechaMoment_a_StringFormatoReporte } from '../../funciones_globales/format';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { obtenerParametros } from '../../funciones_globales/parametros';
import { TextArea } from '../componentes_generales/componentes_formulario/textArea/textarea';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

/*
003	Jefe de Credito                                   
004	Oficial de Credito
*/


const Fieldset = styled.fieldset`  
  border: 2px solid #1d60bd !important;
  position: relative;
  border-radius: 4px;
  padding-top: 2px;
  background-color: #fff;
  padding-left: 10px !important;
  padding-right: 10px !important;
  width: 100%;
`;

const Legend = styled.legend`
  font-size: 13px;
  font-weight: bold;
  background-color: #ffffff;
  color: #1d60bd;
  width: 25%;
  margin-bottom: 0px;
`;

const LabelFormUnique = styled.label`
  display: inline-block;
  font-size: 11px;
  @media(min-width: 800px){
      margin-left: ${props => props.margen_izq?props.margen_izq:'0'}px;
  }
  color: ${props => props.color?props.color:'black'};
  margin-top: ${props => props.margen_arriba?props.margen_arriba:'0'}px;
  padding-left: ${props => props.margen_izq?props.margen_izq:'15'}px;
  padding-right: ${props => props.margen_der?props.margen_der:'15'}px;
`;

const ButtonUnion = styled.button`
  height: 25px;
  padding: 0px 10px;
  font-size: 11px;
  z-index: 0;
`;

const ContenedorModal = styled.div`
  margin-top: 4px;
  height: 150px;
  width: 764px;
`
const ContenedorSubModal = styled.div`
  margin-top: 4px;
  height: 250px;
  width: 500px;
`

const ContenedorHistorial = styled.div`
  margin-top: 4px;
  height: 250px;
  width: 700px;
`

const BotonLink = styled.button`
  color: #337ab7;
  border: none;
  border-radius: 0;
  font-weight: normal;
  background-color: transparent;
  border-color: transparent;
  &:hover {
      border-color: transparent;        
      text-decoration: underline;
  };
  &:focus {
      border-color: transparent;        
  };
  &:active {
      border-color: transparent;        
  };
  font-size: 10px;
  padding-left: ${props => props.margen_izq?props.margen_izq:'6'}px;
  padding-right: ${props => props.margen_der?props.margen_der:'6'}px;
`;

const Container = styled.div`
  margin-top: 20px;
  height: 150px;
  width: 400px;
`;

class FormVen01 extends React.Component{   
  constructor(props) {
    super(props);
    this.state = {                 
      isVisibleModalAnular:false,
      isVisibleModalDetCliente: false,
      isVisibleDetalleVencido: false,
      isVisibleHistorialAprobacion: false,
      pedidoAnular: undefined,
      
      //PARAMETROS
      parametroUltimasCompras: null,
      UserId: null,
      direccionValueDefault: null,
      areaEditPedido: null,
      derivacionActive: false,
      paramIvaActual: null,

      //TEXTBOX
      obsComercial: '',
      obsOficial: '',
      cupoMaximoMod: '',
      obsOficialAprobacion: '',
      obsJefeCredito: '',

      //Cargo User
      cargo: null,
      oficialCodigo: null,

      //LABELS
      labelOficial: '',

      //Totalizadores
      subTotal: 0,
      descuento: 0,
      neto: 0,
      iva: 0,
      totalFactura: 0,

      //Control SubModal
      labelSubModalOP: '',
      labelSubModal: '',
      labelTotalSubModal: 0,
      dataSubModal: [],
      columnDefsSubModal: [
                            {   
                              header: "Tipo",
                              field: "TipoDoc",
                              width: 40,
                              type: "string"
                            },
                            {   
                              header: "Nro. Doc.",
                              field: "NumDoc",
                              width: 100,
                              type: "string"
                            },                                                      
                            {   
                              header: "Importe",
                              field: "Importe",
                              width: 55,
                              type: "num_decimal"
                            },                          
                            {   
                              header: "Saldo",
                              field: "Saldo",
                              width: 55,
                              type: "num_decimal"
                            },
                            {   
                              header: "Devolución",
                              field: "Devolucion",
                              width: 55,
                              type: "num_decimal"
                            },
                            {   
                              header: "Fecha",
                              field: "Fecha",
                              width: 60,
                              type: "string"
                            }, 
                            {   
                              header: "Inic. Pago.",
                              field: "FechaInicioPago",
                              width: 70,
                              type: "string"
                            },                         
                            {   
                              header: "Fch. Ven.",
                              field: "FechaVencimiento",
                              width: 60,
                              type: "string"
                            },
                            {   
                              header: "Plazo",
                              field: "DiasPlazo",
                              width: 40,
                              type: "num_entero"
                            }
                          ],

      //Labels MODAL
      labelPedido: '',
      labelCliente: '',
      labelVendedor: '',
      labelFechaPedido: '',
      labelFechaRecInalambrik: '',
      labelRecDeporpas:'',
      labelVencidoValor: '',
      labelFechaVencida: '',
      labelPorVencerValor: '',
      labelFechaPorVencer: '',
      labelValorChPost:'',
      labelFechaPostCh: '',
      labelCredito: '',
      labelCupo: '',

      //-->Controles Modal
      articulo_sel: null,
      cantidadArt: '',
      direccion_opt: [],
      direccion_sel: null,
      tipoCliente: null,
      observacion: '',

      dataPedidosEliminados: [], //Funciona por cliente
      dataModal: [],
      columnDefsModal:  [
                          {   
                            header: "No.",
                            field: "NroItem",
                            width: 30,
                            type: "string",
                            suppressFilter: true
                          },
                          {   
                            header: "Artículo",
                            field: "Articulo",
                            width: 50,
                            type: "string"
                          },
                          {   
                            header: "Detalle",
                            field: "Detalle",
                            width: 250,
                            type: "string"
                          },                          
                          {   
                            header: "Cant.",
                            field: "Cantidad",
                            width: 50,
                            type: "num_entero",
                            editable: true
                          },                          
                          {   
                            header: "B. Order",
                            field: "BackOrder",
                            width: 60,
                            type: "num_entero"
                          },                         
                          {   
                            header: "Precio",
                            field: "Precio",
                            width: 60,
                            type: "num_decimal"
                          },  
                          {   
                            header: "%. Desc.",
                            field: "Descuento",
                            width: 60,
                            type: "num_decimal"
                          },                        
                          {   
                            header: "Subtotal",
                            field: "Subtotal",
                            width: 60,
                            type: "num_decimal"
                          },
                          {   
                            header: "Cant. Org.",
                            field: "CantidadOriginal",
                            width: 60,
                            type: "num_entero"
                          },
                          {   header: "",
                              field: "eliminar",
                              width: 50,
                              type: "link_elim"                                                
                          }
      ],

      estados: [],
      estado_sel: 'A',
      data_pedidos: [],
      isVisibleModal: false,
      columnDefs: [ 
                    {   header: "No.",
                        field: "NroItem",
                        width: 40,
                        type: "string",
                        suppressFilter: true,
                    },
                    {   header: "Pedido",
                        field: "Pedido",
                        width: 70,
                        type: "string"
                    },
                    {   header: "Fecha Pedido",
                        field: "FechaPedido",
                        width: 120,
                        type: "string"
                    },
                    {   header: "Fecha Ing. Sist.",
                        field: "FechaIngSist",
                        width: 120,
                        type: "string"
                    },
                    {   header: "Cliente",
                        field: "Cliente",
                        width: 225,
                        type: "string"
                    },
                    {   header: "Clase",
                        field: "ClaseCliente",
                        width: 65,
                        type: "string"
                    },
                    {   header: "Vendedor",
                        field: "Vendedor",
                        width: 200,
                        type: "string"
                    },
                    {   header: "Ciudad",
                        field: "Ciudad",
                        width: 100,
                        type: "string"
                    },
                    {   header: "Total",
                        field: "Total",
                        width: 70,
                        type: "num_decimal"
                    },
                    {   header: "Items",
                        field: "ItemsValidos",
                        width: 65,
                        type: "num_entero"
                    },
                    {   header: "Estado",
                        field: "Estado",
                        width: 90,
                        type: "string"
                    },
                    {   header: "Oficial",
                        field: "Oficial",
                        width: 120,
                        type: "string"
                    },
                    {   header: "Observación",
                        field: "Observacion",
                        width: 275,
                        type: "string"
                    },
                    {   header: "Notas",
                        field: "Notas",
                        width: 275,
                        type: "string"
                    }                    
                  ],
      
      motivoAnulacion: '',
      registros: [{label: '20', value: 20}, {label: '50', value: 50}, {label: '100', value: 100}, {label: '200', value: 200}, {label: '300', value: 300}, {label: '400', value: 400}, {label: '500', value: 500}],
      registro_sel: 100,

      //ModalHistorial
      dataHis: [],
      columnDefsHis: [
                    {   
                      header: "No.",
                      field: "Secuencia",
                      width: 30,
                      type: "string",
                      suppressFilter: true
                    },
                    {   
                      header: "Tipo",
                      field: "Tipo",
                      width: 70,
                      type: "string"
                    },
                    {   
                      header: "Fecha",
                      field: "Fecha",
                      width: 110,
                      type: "string"
                    },                          
                    {   
                      header: "Usuario",
                      field: "Usuario",
                      width: 130,
                      type: "string"
                    },                          
                    {   
                      header: "Cargo",
                      field: "Cargo",
                      width: 130,
                      type: "string"
                    },
                    {   
                      header: "Observación",
                      field: "Observacion",
                      width: 210,
                      type: "string"
                    },
                  ]
    };

    //GRID PRINCIPAL
    this.gridOptions = {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      rowSelection: "single",
      singleClickEdit: true,
      getRowStyle:(params)=>{
        if(this.state.cargo === '003'){
          if(params.data.AprobacionOficial===false){
            return {'background-color':'#ff7057'}
          }
        }
        return null;
      },
      onRowDoubleClicked: (event)=>{
        this.setState({isVisibleModalDetCliente: true},()=>{
          this.createDetailsClientePedido(event.data);
          this.setState({labelOficial: event.data.Oficial});
        });
      }
    };

    //GRID DET PEDIDO
    this.gridOptionsModal = {
      context: {
        componentParent: this
      },
      getRowStyle:(params)=>{
        if (params.data.Estado){
            if(params.data.Estado==='X') {
              return {'background-color':'#ff7057'}
            }

            if(params.data.Estado==='M') {
              return {'background-color':'#ffc67f'}
            }

            if(params.data.Estado==='I') {
              return {'background-color':'#4aeccf'}
            }
        }
        return null;
      },
      rowSelection: "single",
      enableCellChangeFlash: true,
      onCellValueChanged: ((event)=>{
        if(isNaN(event.data.Cantidad)){
          event.data.Cantidad = parseInt(event.oldValue,10);
        }else{
          
          if(event.data.EstadoOriginal !=='I'){
            event.data.Estado = 'M';
          }
          event.data.Cantidad = parseInt(event.newValue,10);
          event.data.Subtotal = Math.round(parseInt(event.newValue,10) * parseFloat(event.data.Precio)*100)/100;
          this.activadorCallbacksModalGrid();
        }
        this.apiModal.refreshCells();
      }),
    };

    this.gridOptionsSubModal = {
      context: {
        componentParent: this
      },
      rowSelection: "single",
      enableColResize: true,       
      enableSorting: true
    }

    this.gridOptionsHistorial = {
      context: {
        componentParent: this
      },
      enableColResize: true,
      enableSorting: true,
      enableFilter: true 
    }

    this.onGridReadyModal = this.onGridReadyModal.bind(this);
    this.onGridReady = this.onGridReady.bind(this); 
    this.onGridReadySubModal = this.onGridReadySubModal.bind(this);
    this.onGridReadyHistorial = this.onGridReadyHistorial.bind(this);
    this.consultarPedidosMoviles = this.consultarPedidosMoviles.bind(this);
    this.procesarConsultaPedidosMoviles = this.procesarConsultaPedidosMoviles.bind(this);
    this.generarReporte = this.generarReporte.bind(this);
    this.anularPedido = this.anularPedido.bind(this);
    this.pedirMotivoAnulacionPedido = this.pedirMotivoAnulacionPedido.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);    
    this.handleCantidad = this.handleCantidad.bind(this);
    this.addArticulo = this.addArticulo.bind(this);
    this.verificacionDataNoGuardada = this.verificacionDataNoGuardada.bind(this);
    
    this.aprobacionPedidos = this.aprobacionPedidos.bind(this);
    this.rechazarPedidos = this.rechazarPedidos.bind(this);

    this.revivirPedido = this.revivirPedido.bind(this);
    this.historialAprobaciones = this.historialAprobaciones.bind(this);

    this.detalleSubModal = this.detalleSubModal.bind(this);
    this.getReporteFactura = this.getReporteFactura.bind(this);

    //Derivacion Process
    this.derivacionProcess = this.derivacionProcess.bind(this);
    this.retornoProcess = this.retornoProcess.bind(this);

    //Guardar Detalle Pedido
    this.guardarDetPedido = this.guardarDetPedido.bind(this);
    }
  
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleCantidad(event){
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if(isNaN(value)===false){
      this.setState({
        [name]: value
      });
    }
  }

  activadorCallbacksModalGrid(){
    let array = this.state.dataModal;
    this.setState({dataModal: []}, ()=>{
      this.setState({dataModal: array}, ()=>{
        /* ACTUALIZACION DE TOTAL PEDIDO */
        console.log('GRID ANTES DE TOTALIZAR: ', array);
        let valores = this.totalizarGridPedidos(this.state.dataModal);
        this.setState({subTotal: valores.subtotal,
          descuento: valores.descuento,
          neto: valores.neto,
          iva: valores.iva,
          totalFactura: valores.totalFactura,
        })
      });
    })
  }

  limpiar(){
    this.setState({labelOficial: ''})
  }

  //GRID
  onGridReady(params) {
    this.api = params.api;
    this.columnApi = params.columnApi;
  }

  onGridReadyModal(params){
    this.apiModal = params.api;
    this.columnApiModal = params.columnApi;
  }

  onGridReadySubModal(params){
    this.apiSubModal = params.api;
    this.columnApiSubModal = params.columnApi;
  }

  onGridReadyHistorial(params){
    this.apiHistorial = params.api;
    this.columnApiHistorial = params.columnApi;
  }

  methodFromParent(id, datos_fila){
    var mensaje;

    if(this.state.areaEditPedido === this.props.departamento){
      mensaje = window.confirm("¿Desea eliminar el registro?"); 
      if(mensaje){
        if(datos_fila.hasOwnProperty('Subtotal')===true){
          
          datos_fila.Estado = 'X'
          this.activadorCallbacksModalGrid();
          //this.eliminarPedidoItem(id, datos_fila);
          /* ACTUALIZACION DE TOTAL PEDIDO */
          let valores = this.totalizarGridPedidos(this.state.dataModal);
          this.setState({subTotal: valores.subtotal,
            descuento: valores.descuento,
            neto: valores.neto,
            iva: valores.iva,
            totalFactura: valores.totalFactura,
          })
        }
      }
    }else{
      alert('Operación solo para el area comercial')
    }
  }

  eliminarPedidoItem(id, datos_fila){
    this.setState({ dataModal: this.deleteItemArray(this.state.dataModal, id)})
  }

  deleteItemArray (arr, index) {
    let indice = parseInt(index, 10);
    let arr_tmp = arr.slice(0, indice).concat(arr.slice(indice+1));
    arr_tmp.forEach((item, i)=>{
      item.NroItem = completar_String((i + 1).toString(), '0', 3);
    });
    return arr_tmp;
  }

  immutablePush(array, newItem){
    return [ ...array, newItem ];  
  }


  //REACT CYCLE
  componentDidMount() {            
    let estado = this.state.estado_sel;
    let nroRegistros = this.state.registro_sel; 
    
    Promise.all([
      cargarCatalogos_Otros('VEN-EDITPEDAREA'),
      cargarCatalogoEstados('PedidoInalambrik', 'Status'),
      cargarCatalogos_Otros('PARAM-MESCONSLT'),
      obtenerParametros('IVAACTUAL'),
      this.props.generar_LogAuditoriaIngresoForm('0401')
    ])
    .then(([areaEditPedido, result_estados , paramMes, paramIvaActual]) => {      
      let estados=[];
      this.setState({areaEditPedido: areaEditPedido[0].value, 
        paramIvaActual: parseFloat(paramIvaActual[0].IvaActual)})

      result_estados.forEach(estado=>{
        if (estado.value==='N' || estado.value==='I' || estado.value==='A'){
          estados.push(estado);
        }
      });

      this.cargarObjetos(`/usuarios/${this.props.usuario}`).then((det)=>{
        let codOficial = null
        this.setState({UserId: det.UsuarioId})
        if(det.OficialCredito && this.props.cargo==='004'){
          codOficial = det.OficialCredito;
        }

        this.consultarPedidosMoviles(estado, nroRegistros, codOficial).then((result_pedidos)=>{
          this.setState({data_pedidos: result_pedidos, estados, 
            cargo: this.props.cargo, oficialCodigo: codOficial, 
            parametroUltimasCompras: parseInt(paramMes[0].value,10)});
            
          //Validacion por oficial
          if(this.props.cargo==='004' ){
            this.columnApi.setColumnVisible('Oficial',false)
            this.setState({labelOficial: `${det.OficialCredito} - ${det.NombreUsuario.toUpperCase()}`,
            derivacionActive: true})
          }

          console.log('CARGO: ', this.props.cargo)
        }) 
      })
    })
    .catch(error=>{
      alert(error);
    });
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0401');
  }

  //METHODS
  cargarObjetos(ruta){
    return new Promise((resolve, reject) => {
        global_axios.get(ruta)
        .then((response)=>{
            resolve(response.data)
        })
        .catch((err)=>{
            reject(err);
        });
    });
  }

  createDetailsClientePedido(fila){
    global_axios({
      method: 'GET', 
      url: `/pedidosmoviles/${fila.Pedido}`
    })
    .then((response)=>{

      let detArrayPedido = [];
      if(response!==null){
        let detPedido = response.data;
          
        detArrayPedido = this.formateoDetallePedido(detPedido);
        

        /* ACTUALIZACION DE TOTAL PEDIDO */
        let valores = this.totalizarGridPedidos(detArrayPedido);
        this.setState({subTotal: valores.subtotal,
          descuento: valores.descuento,
          neto: valores.neto,
          iva: valores.iva,
          totalFactura: valores.totalFactura,
        })
        
        //Creacion de combo de direcciones
        if(detPedido.cli){
          this.procesoDireccionesCliente(detPedido)
        }
        
        this.setState({dataModal: detArrayPedido, labelPedido: detPedido.Pedido,
          labelCliente: detPedido.cli!==null?`${detPedido.cli.Nombre} - (${detPedido.Cliente})`:'N/A',
          labelVendedor:detPedido.vend!==null?detPedido.vend.Nombre:'N/A',
          labelFechaPedido: fila.FechaPedido,
          labelRecDeporpas: fila.FechaIngSist,
          labelDireccion: detPedido.cli!==null?detPedido.cli.direccion_principal:'N/A',
          tipoCliente: detPedido.cli.Tipo, labelCupo: (detPedido.cli?detPedido.cli.Cupo:0) 
        })

        //DATA DE REDIRECCION
        this.setState({obsOficial: fila.ObsOficialRedireccion?fila.ObsOficialRedireccion:'',
          obsComercial: fila.ObsComercial?fila.ObsComercial:'',
          cupoMaximoMod: fila.CupoMaximoEdicion?fila.CupoMaximoEdicion:'',
          obsOficialAprobacion: fila.ObsOficialAprobacion?fila.ObsOficialAprobacion:'',
          obsJefeCredito: fila.ObsJefeCredito?fila.ObsJefeCredito:''
        })

        var cliente = detPedido.Cliente.trim()
        //Detalles de fechas
        global_axios({
          method: 'GET', 
          url: `/clientes?cliente=${cliente}&dcartera=true`
        })
        .then((response)=>{
          if(response!==null){
            let data = response.data;

            this.setState({labelVencidoValor: data.VencidoValor,
              labelFechaVencida: data.FechaVencido,
              labelPorVencerValor: data.PorVencerValor,
              labelFechaPorVencer: data.FechaPorVencer,
              labelValorChPost: data.ValorChequePosFechado,
              labelFechaPostCh: data.FechaChequesPostfechados,
              labelCredito: data.Credito!==null?data.Credito:0})
          }
        })
        .catch((error)=> {
          alert(error.response.data.msg?error.response.data.msg:error.message);
        }); 
      }        
    })
    .catch((error)=> {
      alert(error.response.data.msg?error.response.data.msg:error.message);
    });  
  }

  //Formatear JSON para car
  formateoDetallePedido(detPedido){
    
    let detArrayPedido = [];

    detPedido.detalle_ped.forEach((DET, i)=>{
      

      if(this.state.cargo === '003' || this.state.cargo === '004'){
        if(DET.IndicadorModificacion!=='A'){
          let item = {};
          let precioUnitDscto = 0; // PRECIO UNITARIO DESC.

          item.NroItem = completar_String((i + 1).toString(), '0', 3);
          item.Articulo = DET.Articulo;
          item.Detalle = DET.art!==null?DET.art.nombre:'N/A';
          item.Cantidad = DET.Cantidad;
          item.BackOrder = DET.BackOrder;
          item.Precio = DET.Precio;
          item.Subtotal = Math.round((parseFloat(item.Precio)*parseFloat(item.Cantidad,10))*100)/100;
          item.Descuento = DET.art?DET.art.Descuento:0; //Unidad en %

          //CALCULO DESCUENTO
          precioUnitDscto = Math.round((item.Precio * (item.Descuento/100))*100)/100;
          item.DescuentoValLinea = item.Cantidad * precioUnitDscto;       
          item.Subtotal = Math.round((item.Cantidad*item.Precio)*100)/100;

          item.Estado = DET.IndicadorModificacion===null?'':DET.IndicadorModificacion; //GUARDARA I => Insertado Manual ; A => Anulado ; M => Modificado
          item.CantidadOriginal = DET.CantidadOriginal===null?DET.Cantidad:DET.CantidadOriginal;
          item.EstadoOriginal = item.Estado;
          item.Iva = DET.art?DET.art.Iva:false; //INDICADOR DE CARCULA IVA
          
          detArrayPedido.push(item);
        }
      }else if(this.props.departamento === this.state.areaEditPedido){
        let item = {};
        let precioUnitDscto = 0; // PRECIO UNITARIO DESC.

        item.NroItem = completar_String((i + 1).toString(), '0', 3);
        item.Articulo = DET.Articulo;
        item.Detalle = DET.art!==null?DET.art.nombre:'N/A';
        item.Cantidad = DET.Cantidad;
        item.BackOrder = DET.BackOrder;
        item.Precio = DET.Precio;
        item.Subtotal = Math.round((parseFloat(item.Precio)*parseFloat(item.Cantidad,10))*100)/100;
        item.Descuento = DET.art?DET.art.Descuento:0; //Unidad en %

        precioUnitDscto = Math.round((item.Precio * (item.Descuento/100))*100)/100;
        //console.log('CALCULO DESC: ', item.Cantidad ,  precioUnitDscto)
        item.DescuentoValLinea = item.Cantidad * precioUnitDscto;       
        item.Subtotal = Math.round((item.Cantidad*item.Precio)*100)/100;

        //CALCULO DESCUENTO
        if(item.Descuento > 0){
          console.log('CALCULO DESC: ', item.Precio ,  item.Descuento)
          console.log('precioUnitDesc: ', precioUnitDscto)
        }

        item.Estado = DET.IndicadorModificacion===null?'':DET.IndicadorModificacion; //GUARDARA I => Insertado Manual ; A => Anulado ; M => Modificado
        item.CantidadOriginal = DET.CantidadOriginal===null?DET.Cantidad:DET.CantidadOriginal;
        item.EstadoOriginal = item.Estado; 
        item.Iva = DET.art?DET.art.Iva:false; //INDICADOR DE CARCULA IVA    
        detArrayPedido.push(item);
      }
    })

    return detArrayPedido;
  }

  //Totalizar grid de pedidos
  totalizarGridPedidos(array){
    let valores = {};
    let subtotal = 0;
    let descuento = 0;
    let baseIva = 0;
    

    array.forEach((DET)=>{
      if(DET.Estado!=='X'){
        let precioUnitDesc = 0;

        subtotal+= Math.round(((DET.Cantidad * DET.Precio))*100)/100;
        //+=Math.round(DET.Subtotal*100)/100;
        precioUnitDesc = Math.round((DET.Precio * (DET.Descuento/100))*100)/100
        descuento+= Math.round((DET.Cantidad * precioUnitDesc)*100)/100; 
        
        if(DET.Iva===true){ 
          baseIva+= Math.round(((DET.Cantidad * DET.Precio) - (DET.Precio * (DET.Descuento/100)))*100)/100;
        }
      }
    })

    

    valores.subtotal =  Math.round(subtotal*100)/100;
    valores.descuento = Math.round(descuento*100)/100;
    valores.neto = Math.round((subtotal-descuento)*100)/100;
    valores.iva = Math.round((baseIva * this.state.paramIvaActual/100)*100)/100;
    valores.totalFactura = Math.round((valores.neto + valores.iva)*100)/100; 
    console.log('VALORES: ', valores)
    return valores
  }

  procesoDireccionesCliente(pedido){
    let cliente = pedido.cli;
    var array = [];
    var selected = {};
    let item = {};

    //Dirección Principal
    item.value = 0;
    item.label = cliente.direccion_principal?cliente.direccion_principal:'N/A';
    item.ciudad = cliente.Ciudad?cliente.Ciudad:'N/A';
    array.push(item);

    selected = item;
    this.setState({direccionValueDefault: pedido.idDireccion!==null?pedido.idDireccion:0})

    //Direcciones Secundarias
    if(cliente.detalle_direcciones.length > 0){
      cliente.detalle_direcciones.forEach((DIR)=>{
        let item = {};
        item.value = DIR.secuencia;
        item.label = DIR.direccion;
        item.ciudad = DIR.CodCiudad;
        if(pedido.idDireccion!==null){
          if(DIR.secuencia === pedido.idDireccion)
          selected = item
        }        
        array.push(item);
      })
    }
    this.setState({direccion_opt: array, direccion_sel: selected});
  }

  procesarConsultaPedidosMoviles(){
    let estado = this.state.estado_sel;
    let nroRegistros = this.state.registro_sel;
    
    if (estado===null || estado===undefined){
      alert('Debe seleccionar el estado que desea consultar.');
      return;
    }

    if (nroRegistros===null || nroRegistros===undefined){
      alert('Debe seleccionar el número de registros que desea consultar.');
      return;
    }

    Promise.all([              
      this.consultarPedidosMoviles(estado, nroRegistros, this.state.oficialCodigo)      
    ])
    .then(([result_pedidos]) => {      
      this.setState({data_pedidos: result_pedidos});
    })
    .catch(error=>{
      alert(error);
    });
  }

  consultarPedidosMoviles(estado, nroRegistros, codOficial){
    return new Promise((resolve, reject) => {
      var url = '/pedidosmoviles?estado=' + estado + '&limit=' + nroRegistros;
      
      if(codOficial!==null){
        url = url+'&codOficial=' + codOficial;
      }else if(this.props.departamento === this.state.areaEditPedido){
        url += '&departamento='+this.props.departamento 
      }

      global_axios({
        method: 'GET', 
        url
      })
      .then((response)=> {      
        let data_pedidos = response.data;      
        console.log('DATA PED: ', data_pedidos)
        data_pedidos.forEach((pedido, i)=> {     
          pedido.NroItem= completar_String((i+1).toString(), '0', 3);
          pedido.Cliente = pedido.Cliente + ' - ' + pedido.NombreCliente;
          pedido.Vendedor = pedido.Vendedor + ' - ' + pedido.NombreVendedor;
          pedido.FechaPedido = pedido.FechaPedido + ' ' + pedido.HoraPedido;
          pedido.FechaIngSist = pedido.FechaIngSist + ' ' + pedido.HoraIngSist;    
        });
        resolve(data_pedidos); 
      })
      .catch((error)=> {
        reject(error.response.data.msg?error.response.data.msg:error.message);
      });
    });
  }

  generarReporte(){
    let filasSeleccionadas = this.api.getSelectedRows();
    
    if (this.state.data_pedidos.length===0){
      alert('No existen pedidos.');
      return;
    }

    if (filasSeleccionadas[0]===undefined){
      alert('Debe seleccionar el pedido que desee imprimir.');
      return;
    }
    
    let pedidoImprimir = filasSeleccionadas[0];
    
    global_axios({
      method: 'PUT',
      url: '/pedidosmoviles/' + pedidoImprimir.Pedido,
      data: {Status: 'I'}
    })
    .then(()=>{
      this.procesarConsultaPedidosMoviles();      
    })
    .catch((error)=> {
      alert(error.response?error.response.data.msg:error.message);
    });
    
    visualizarReporteEnPdf('&rpt=1&param1=' + pedidoImprimir.Pedido);
    
  }

  pedirMotivoAnulacionPedido(){
    let filasSeleccionadas = this.api.getSelectedRows();
    
    if (this.state.data_pedidos.length===0){
      alert('No existen pedidos.');
      return;
    }

    if (filasSeleccionadas[0]===undefined){
      alert('Debe seleccionar el pedido que desee anular.');
      return;
    }

    if (filasSeleccionadas[0].Estado.toString().startsWith('N')){
      alert('El pedido seleccionado ya se encuentra anulado.');
      return;
    }
    
    this.setState({pedidoAnular: filasSeleccionadas[0], motivoAnulacion:'', isVisibleModalAnular: true});        
  }

  anularPedido(){
    if (this.state.pedidoAnular===undefined){
      alert('No ha seleccionado el pedido que desea anular.');
      return;
    }

    if (this.state.motivoAnulacion.toString().trim()===''){
      alert('Debe indicar un motivo de anulación.');
      return;
    }

    let i;    
    for(i=0; i<this.state.data_pedidos.length; i++){
      if (this.state.data_pedidos[i].Pedido === this.state.pedidoAnular.Pedido){                 
        break;
      }
    }

    this.props.cambiar_VisualizacionLoading(true);

    global_axios({
      method: 'PUT',
      url: '/pedidosmoviles/' + this.state.pedidoAnular.Pedido,
      data: {Observacion: this.state.motivoAnulacion, Status: 'N'}
    })
    .then(()=> {
      this.props.cambiar_VisualizacionLoading(false);
      alert('El proceso de anulación se ejecutó correctamente.');
      this.setState({ data_pedidos: this.deleteItemArray(this.state.data_pedidos, i), isVisibleModalAnular:false });
    })
    .catch((error)=> {
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  addArticulo(){
    let proceder = true;
    let errors = '';

    if(this.state.articulo_sel===null){
      proceder = false;
      errors+='- Ingrese un artículo\n'
    }

    if(this.state.cantidadArt===''){
      proceder = false;
      errors+='- Ingrese una cantidad\n'
    }

    if(proceder===true){
      
      if(this.validItemsDuplicados(this.state.articulo_sel.value)){
        let mensaje = window.confirm('El artículo ya existe, ¿Reemplazar la cantidad?'); 
            
        if(mensaje){
          this.state.dataModal.forEach((DET)=>{
            if(DET.Articulo === this.state.articulo_sel.value){
              DET.Cantidad = this.state.cantidadArt;
            }
            this.apiModal.refreshCells();
          })
        }
      }else{
        this.cargarObjetos(`articulos/${this.state.articulo_sel.value}`).then((articulo)=>{
          let data = this.state.dataModal;
          let precioUnitDscto = 0; // PRECIO UNITARIO DESC.
          
          let item = {};
          item.NroItem = completar_String((data.length+1).toString(), '0', 3);
          item.Articulo = this.state.articulo_sel.value; 
          item.Detalle = articulo.descripcion;
          item.Cantidad = parseInt(this.state.cantidadArt,10);
          item.CantidadOriginal = parseInt(this.state.cantidadArt,10);
          item.BackOrder = 0;
          item.Precio = this.selPrecioArticulo(articulo, this.state.tipoCliente);
          item.Descuento = articulo.descuento?parseFloat(articulo.descuento):0;
          
          //CALCULO DESCUENTO
          precioUnitDscto = Math.round((item.Precio * (item.Descuento/100))*100)/100;
          item.DescuentoValLinea = item.Cantidad * precioUnitDscto;       
          item.Subtotal = Math.round((item.Cantidad*item.Precio)*100)/100;

          item.Estado = 'I';
          item.EstadoOriginal = 'I';
          item.Iva = articulo.gravaiva;

          console.log('VALOR DESC TOTAL', item.DescuentoValLinea, 'Total desc: ', precioUnitDscto);
          
          
          this.setState({dataModal: this.immutablePush(this.state.dataModal,item),
            articulo_sel: null, cantidadArt: ''}, ()=>{
              
              /* ACTUALIZACION DE TOTAL PEDIDO */
              let valores = this.totalizarGridPedidos(this.state.dataModal);
              this.setState({subTotal: valores.subtotal,
                descuento: valores.descuento,
                neto: valores.neto,
                iva: valores.iva,
                totalFactura: valores.totalFactura
              })

            })
        })
      }
    }else{
      alert(errors);
    }
  }

  selPrecioArticulo(articulo, tipoCliente){
    let precio = 0;
    if(articulo!==null && tipoCliente!==null){
      switch (tipoCliente) {
        case 'D':
          precio = articulo.preciodetallista;
          break;
        case 'M':
          precio = articulo.preciomayorista;
          break;
        case 'P':
          precio = articulo.pvp;
          break;
        case 'C':
          precio = articulo.preciodistribuidor;
          break
        default:
          precio = 0;
          break;
      }
    }

    return precio;
  }

  validItemsDuplicados(codArticulo){
    let duplicado = false;

    this.state.dataModal.forEach((DET)=>{
      if(DET.Articulo === codArticulo){
        duplicado = true;
      }
    })

    return duplicado;
  }

  verificacionDataNoGuardada(){
    var changed = this.detectionChanges();

    if(changed===true){
      let msg = window.confirm('Al cerrar perdera los cambios realizados, ¿Continuar?')
      if(msg){
        this.setState({isVisibleModalDetCliente: false, dataPedidosEliminados: [], dataModal: [], direccionValueDefault: null, observacion: ''})
        this.procesarConsultaPedidosMoviles();
      }
    }else{
      this.setState({isVisibleModalDetCliente: false, dataPedidosEliminados: [], dataModal: [], direccionValueDefault: null, observacion: ''});
      this.procesarConsultaPedidosMoviles();
    }
  }

  //Detecta cambios en el Modal de aprobacion
  detectionChanges(){
    let changed = false
    if(this.state.isVisibleModalDetCliente===true){
      //console.log("Direccion_sel: ", this.state.direccion_sel)
      if(this.state.direccion_sel!==null){
        changed = false
        if(this.state.direccion_sel.value!==0){
          changed = true;
        }
      }
  
      // if(this.state.observacion!==''){
      //   let fila = this.api.getSelectedRows()[0];
      //   let Observacion = fila.Observacion?fila.Observacion:'';
      //   if(Observacion !== this.state.observacion){
      //     changed = true;
      //   }else{
      //     changed = false;
      //   }
      // }
  
      this.state.dataModal.forEach((DET)=>{
        if(DET.Estado!==DET.EstadoOriginal){
          changed = true;
        }
      })
    }
    //console.log("Changed: ", changed)
    return changed;
  }

  detalleSubModal(parametro){
    this.setState({isVisibleDetalleVencido: true,
    dataSubModal: [], labelTotalSubModal: 0, labelSubModal: parametro},()=>{

      let fila = this.api.getSelectedRows();
      let cliente = fila[0].Cliente.toString().split('-')[0].trim()

      if(parametro==='ULTIMAS COMPRAS'){
        let mes = parseInt(this.state.parametroUltimasCompras,10)
        let fechaProceso = getFechaProcesoPorModulo('04');
        let fechaConsulta = formatearFechaMoment_a_StringFormatoReporte(moment(fechaProceso, 'DD/MM/YYYY').subtract(mes, 'months'));
        global_axios({
          method: 'GET', 
          url: `clientes/${cliente}/facturas?fechadesde=${fechaConsulta}`
        })
        .then((response)=>{
          let data = response.data;
          if(data.length > 0){
            let acum = 0;
            let arrayTemp = [];
            data.forEach((DET)=>{
              let item = {};
              item.NumDoc = DET.Establec+'-'+DET.PtoEmision+'-'+DET.NroFactura;
              item.TipoDoc = 'FAC';
              item.Importe = Math.round(DET.Importe*100)/100;
              item.Devolucion = Math.round(DET.Devolucion*100)/100;
              item.Fecha = DET.Fecha;
              item.FechaVencimiento = this.formatFecha(DET.FechaVencimiento);
              item.FechaInicioPago =  DET.FechaInicioPago;
              item.DiasPlazo = DET.TerminoPago;
              item.Comprobante = DET.Factura;
              acum += DET.Importe-DET.Devolucion;
              arrayTemp.push(item);
            })
            this.setState({dataSubModal: arrayTemp, labelTotalSubModal: Math.round(acum*100)/100})
          }

          this.setState({labelSubModalOP: 'Total Importe - (Devoluciones)'}, ()=>{
            this.columnApiSubModal.setColumnVisible('Saldo',false)
            this.columnApiSubModal.setColumnVisible('Devolucion',true)
          });
        })
        .catch((error)=> {
          alert(error.response.data.msg?error.response.data.msg:error.message);
        });
      }else{
        let fechaProceso = getFechaProcesoPorModulo('04');
        global_axios({
          method: 'GET', 
          url: `/clientes?tipoproceso=${parametro}&cliente=${cliente}&fechaProceso=${fechaProceso}`
        })
        .then((response)=>{
          let data = response.data;
          if(data.length > 0){
  
            let acum = 0;
            let arrayTemp = [];
            data.forEach((DET)=>{
              let item = {};
              
              item.NumDoc = DET.NumDoc;
              item.TipoDoc = DET.TipoDoc;
              item.Importe = DET.Importe;
              item.Saldo = DET.Saldo;
              item.Fecha = this.formatFecha(DET.Fecha);
              item.FechaVencimiento = this.formatFecha(DET.FechaVencimiento);
              item.FechaInicioPago =  this.formatFecha(DET.FechaInicioPago);
              item.DiasPlazo = DET.DiasPlazo;
              acum += DET.Saldo;
              arrayTemp.push(item);
            })
  
            this.setState({dataSubModal: arrayTemp, labelTotalSubModal: Math.round(acum*100)/100});
          }

          this.setState({labelSubModalOP: 'Total Saldo'}, ()=>{
            this.columnApiSubModal.setColumnVisible('Saldo',true)
            this.columnApiSubModal.setColumnVisible('Devolucion',false)
          });
        })
        .catch((error)=> {
          alert(error.response.data.msg?error.response.data.msg:error.message);
        });
      }
    })
  }

  formatFecha(fecha){
    let fechaFinal='';
    if(fecha!==null){
      let fechaPart;
    
      fechaPart = fecha.substring(0, 10).split('-')
      fechaFinal = `${fechaPart[2]}/${fechaPart[1]}/${fechaPart[0]}`
    }
    
    return fechaFinal
  }

  revivirPedido(){
    let selected = this.apiModal.getSelectedRows()[0];
    let estadoMod = null;
    
    if(selected !== undefined){
      estadoMod = parseInt(selected.Cantidad,10)===parseInt(selected.CantidadOriginal,10)?selected.EstadoOriginal:'M';
      if(selected.Estado==='X'){
        this.state.dataModal.forEach((DET)=>{
          if(selected.Articulo === DET.Articulo){
            DET.Estado = estadoMod;
          }
        })
        this.activadorCallbacksModalGrid();
      }else{
        alert('El item seleccionado no se encuentra eliminado')
      }
    }else{
      alert('Seleccione un artículo a añadir')
    }
  }

  getReporteFactura(){
    let codigoComprobante = this.apiSubModal.getSelectedRows()[0];
    if(codigoComprobante){
      global_axios({
        method: 'GET',
        url: '/reportes?TipoAsiento=FAC'
      }).then((response)=>{
        if(response.data.length > 0){
          let rpt = response.data[0];
          visualizarReporteEnPdf('&rpt=' + rpt.CodigoReporte + '&param1='+codigoComprobante.Comprobante );
        }
      }).catch((error)=>{
        alert(error.response.data.msg?error.response.data.msg:error.message);
      })      
    }else{
      alert('Seleccione un documento.')
    }    
  }

  getDiasVencidoCliente(fechaVencido){
    let dias = 0;
    if(fechaVencido!=='N/A'){
      let fecha = moment(fechaVencido, 'DD/MM/YYYY');
      let fechaProceso = getFechaProcesoPorModulo('04');
      let now = moment(fechaProceso, 'DD/MM/YYYY');
      
      dias = now.diff(fecha, 'days')
    }

    return dias;
  }

  //ACCIONS MODAL
  aprobacionPedidos(){
    
    var continuar = true;
    var errors = ''

    if(this.state.cargo === '004' && !this.state.obsOficialAprobacion){
      continuar = false;
      errors += '- Ingrese una observacion para la aprobacion.\n'
    }

    if(this.state.cargo === '003' && !this.state.obsJefeCredito){
      continuar = false;
      errors += '- Ingrese una observacion para la aprobacion.\n'
    }

    if(continuar === true){

      var msg = window.confirm('¿Aprobar el pedido en el estado actual?')
      if(msg){
        var data = {};

        data = this.api.getSelectedRows()[0];
        data.Observacion = this.state.observacion;
        data.Observacion = data.Observacion.toUpperCase();
        
        if(this.state.cargo === '004'){
          data.obsOficialAprobacion = String(this.state.obsOficialAprobacion).toUpperCase();
        }
        
        data.idDireccion = this.state.direccion_sel.value;
        data.DPedido = this.state.dataModal;
        data.Oficial = data.Oficial.split('-')[0].trim();
        data.Cargo = this.props.cargo;
        data.UsuarioId = this.state.UserId;
        data.Cupo = this.state.labelCupo?parseFloat(this.state.labelCupo):0;
        data.DiasVencido = this.getDiasVencidoCliente(this.state.labelFechaVencida);
        data.TipoHistorial = 'A';

        global_axios({
          method: 'POST', 
          url: `/pedidosmoviles/${data.Pedido}/aprobacion`,
          data
        })
        .then((response)=>{
          alert(response.data.msg);

          this.verificacionDataNoGuardada();
        })
        .catch((error)=> {
          alert(error.response.data.msg?error.response.data.msg:error.message);
        });
      }
    }else{
      alert(errors)
    }
  }

  rechazarPedidos(){
    var continuar = true;
    var errors = ''

    if(this.state.cargo === '003' && !this.state.obsJefeCredito){
      continuar = false;
      errors += '- Ingrese una observacion para el rechazo.\n'
    }

    if(continuar === true){
      var msg = window.confirm('¿Rechazar el pedido actual?')
      if(msg){

        var data = {};

        data = this.api.getSelectedRows()[0];
        data.ObsJefeCredito = String(this.state.obsJefeCredito).toUpperCase();
        
        data.idDireccion = this.state.direccion_sel.value;
        data.DPedido = this.state.dataModal;
        data.Cargo = this.props.cargo;
        data.UsuarioId = this.state.UserId;
        data.Cupo = this.state.labelCupo?parseFloat(this.state.labelCupo):0;
        data.DiasVencido = this.getDiasVencidoCliente(this.state.labelFechaVencida);
        data.TipoHistorial = 'R';

        global_axios({
          method: 'PUT', 
          url: `/pedidosmoviles/${data.Pedido}/rechazo`,
          data
        })
        .then((response)=>{
          alert(response.data.msg);          
        })
        .catch((error)=> {
          alert(error.response.data.msg?error.response.data.msg:error.message);
        });
      }
    }else{
      alert(errors)
    }
  }

  historialAprobaciones(){
    var data = {};
    this.setState({isVisibleHistorialAprobacion: true, dataHis: [], })

    data = this.api.getSelectedRows()[0];
    data.Observacion = this.state.observacion.toUpperCase();

    global_axios({
      method: 'GET', 
      url: `/pedidosmoviles/${data.Pedido}/historialaprobacion`,
      data
    })
    .then((response)=>{
      let historial = response.data;
      
      if(historial.length > 0){
        historial.forEach((HIS)=>{
          if(HIS.Tipo){
            if(HIS.Tipo==='A'){
              HIS.Tipo = 'APROBADO';
            }else{
              HIS.Tipo = 'RECHAZADO';
            }
          }
          if(HIS.Fecha){
            let fechapart = HIS.Fecha.substring(0,10).split('-');
            HIS.Fecha = `${fechapart[2]}/${fechapart[1]}/${fechapart[0]} ${HIS.Fecha.substring(11,19)}`;
          }
          HIS.Usuario = HIS.Usuario?HIS.Usuario.toUpperCase():'N/A';
          HIS.Cargo = HIS.Cargo?HIS.Cargo.toUpperCase():'N/A';
          HIS.Observacion = HIS.Observacion?HIS.Observacion.toUpperCase():'N/A';
        })

        this.setState({dataHis: historial})
      }
    })
    .catch((error)=> {
      alert(error.response.data.msg?error.response.data.msg:error.message);
    });
  }

  guardarDetPedido(){
    let msg = window.confirm('¿Modificar pedido al estado actual?');

    if(msg){
      let data = {};
      let pedido = this.api.getSelectedRows()[0].Pedido;

      data.Pedido = pedido;
      data.Total_Factura = this.state.totalFactura;
      data.Descuento = this.state.descuento;
      data.Iva = this.state.iva
      data.SubDescuento = this.state.subTotal
      data.ArrayPedido = this.state.dataModal;
      data.UpdateDetPedido = true;

      global_axios({
        method: 'PUT', 
        url: `/pedidosmoviles/${data.Pedido}`,
        data
      })
      .then((response)=>{
        console.log('Pedido: ', pedido)
        console.log('Cargo: ', this.state.cargo)
        let fila = {};
        fila.Pedido = pedido
        //this.createDetailsClientePedido(fila);
        alert(response.data.msg);
        
      })
      .catch((error)=> {
        alert(error.response.data.msg?error.response.data.msg:error.message);
      });
    }
  }

  //Redireccion
  derivacionProcess(){
    var errors = '';
    var continuar = true;

    if(!this.state.obsOficial){
      continuar = false;
      errors += '- Ingrese las notas a enviar a comercial\n' 
    }

    if(!this.state.cupoMaximoMod){
      continuar = false;
      errors += '- Ingrese el maximo valor del pedido a editar\n' 
    }

    if(continuar === true){

      let data = {};

      data.ObsOficialRedireccion = this.state.obsOficial;
      data.AreaModificaPedido = this.state.areaEditPedido;
      data.CupoMaximoEdicion = Math.round(parseFloat(this.state.cupoMaximoMod,10)*100)/100;
      data.ArrayPedidos = this.api.getSelectedRows();
      data.UsuarioId = this.props.usuario;
      data.Departamento = this.props.departamento;

      global_axios({
        method: 'POST', 
        url: `/redireccionporcargo/${this.state.cargo}/derivacion`,
        data
      })
      .then((response)=>{
        alert(response.data.msg);
        this.setState({isVisibleModalDetCliente: false});
        
        let estado = this.state.estado_sel;
        let nroRegistros = this.state.registro_sel; 

        this.consultarPedidosMoviles(estado, nroRegistros, this.state.oficialCodigo).then((result_pedidos)=>{
          this.setState({data_pedidos: result_pedidos 
            // cargo: this.props.cargo, oficialCodigo: codOficial, 
            // parametroUltimasCompras: parseInt(paramMes[0].value,10)
          });
        })
      })
      .catch((error)=> {
        alert(error.response.data.msg?error.response.data.msg:error.message);
      });

    }else{
      alert(errors)
    }

  }

  retornoProcess(){
    var errors = '';
    var continuar = true;

    if(!this.state.obsComercial){
      continuar = false;
      errors += '- Ingrese notas a enviar al oficial\n' 
    }

    if(continuar === true){
      let data = {};

      data.ObsComercial = this.state.obsComercial;
      data.AreaModificaPedido = this.state.areaEditPedido;
      data.CupoMaximoEdicion = Math.round(parseFloat(this.state.cupoMaximoMod,10)*100)/100;
      data.ArrayPedidos = this.api.getSelectedRows();
      data.UsuarioId = this.props.usuario;
      data.Departamento = this.props.departamento;

      global_axios({
        method: 'POST', 
        url: `/redireccionporcargo/${this.state.cargo}/retorno`,
        data
      })
      .then((response)=>{
        alert(response.data.msg);
        this.setState({isVisibleModalDetCliente: false});
        
        let estado = this.state.estado_sel;
        let nroRegistros = this.state.registro_sel; 

        this.consultarPedidosMoviles(estado, nroRegistros, this.state.oficialCodigo).then((result_pedidos)=>{
          this.setState({ data_pedidos: result_pedidos });
        })
      })
      .catch((error)=> {
        alert(error.response.data.msg?error.response.data.msg:error.message);
      });


    }else{
      alert(errors)
    }
  }

  //Sumatoria de valores
  calculoTotalPedido(){

  }

  render(){        
        return(
          <div>
            <ContenedorForm porc_ancho={94}>
              <HeaderForm>
                <TituloForm>Recepción/Aprobación de Pedidos Móviles</TituloForm>
              </HeaderForm>
              <CuerpoForm>
                <Row>
                  <ContainerCol className='col-md-2'>
                    <LabelForm>Estado: </LabelForm>
                    <ReactSelect options={ this.state.estados } value={this.state.estado_sel} func_onChange={(value)=>{this.setState({estado_sel: value!==null?value.value:null})}}/>
                  </ContainerCol>
                  <ContainerCol className='col-md-1'>
                    <LabelForm>Registros: </LabelForm>
                    <ReactSelect options={ this.state.registros } value={this.state.registro_sel} func_onChange={(value)=>{this.setState({registro_sel: value!==null?value.value:null})}}/>
                  </ContainerCol>
                  <ContainerCol className='col-md-2' margen_arriba='20'>
                    {/* <ContainerBoton> */}
                      <button type='button' className='btn btn-success btn-sm' onClick={this.procesarConsultaPedidosMoviles}><i className='fa fa-search fa-lg'/> Consultar</button>
                    {/* </ContainerBoton> */}
                  </ContainerCol>
                  <ContainerCol className='col-md-3 col-md-offset-4' margen_arriba='20' isInvisible={this.props.cargo==='004'?false:true}>
                    <LabelForm>Of. Crédito: {this.state.labelOficial}</LabelForm>
                  </ContainerCol>
                </Row>
                <Row>   
                  <ContainerCol className='col-md-12'>                    
                    <AgGridRender altura='440px' data={this.state.data_pedidos} columnas={this.state.columnDefs}
                      gridOptions={this.gridOptions} onGridReady={this.onGridReady}/>
                  </ContainerCol>
                </Row>
                <Row>                
                  <ContainerCol className='col-sm-8'>
                    <LabelNota>* Haga doble clic sobre el pedido ver el detalle del mismo.</LabelNota>
                  </ContainerCol>
                  <ContainerCol className='col-md-4'>
                    <div className='btn-group pull-right'>                      
                      <button type='button' className='btn btn-info btn-sm' onClick={this.generarReporte}><i className="fa fa-print fa-lg"/> Imprimir</button>                      
                      <button type='button' className='btn btn-danger btn-sm' onClick={this.pedirMotivoAnulacionPedido}><i className='fa fa-window-close fa-lg'/> Anular</button>
                    </div>
                  </ContainerCol>
                </Row>
              </CuerpoForm>
            </ContenedorForm>

            <ModalResponsive open={this.state.isVisibleModalDetCliente} onClose={this.verificacionDataNoGuardada}>  
              <HeaderForm>
                <TituloForm>{`No. Pedido: ${this.state.labelPedido}`}</TituloForm>
              </HeaderForm>
              <CuerpoForm>
                <ContenedorModal>
                  {/*DATOS CABECERA COMERCIAL*/}
                  <Row margen_arriba='3' isInvisible={this.props.departamento!=='002'?true:false}>
                    <ContainerCol className='col-sm-6' margen_abajo='0'> 
                      <Row>
                        <ContainerCol className='col-md-3'>
                          <LabelForm margen_abajo='0'>Vendedor: </LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-md-9' >
                          <LabelForm margen_abajo='0'>{this.state.labelVendedor}</LabelForm>
                        </ContainerCol>
                      </Row> 
                      <Row>
                        <ContainerCol className='col-md-3'>
                          <LabelForm margen_abajo='0'>Dirección: </LabelForm>    
                        </ContainerCol>
                        <ContainerCol className='col-md-9' >
                          <ReactSelect options={ this.state.direccion_opt } value={this.state.direccion_sel} func_onChange={(value)=>{this.setState({direccion_sel: value})}}/>
                        </ContainerCol>
                      </Row>
                      <Row>
                          <ContainerCol className='col-md-3'>
                            <LabelForm margen_abajo='0'>Of.Crdto: </LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-9' >
                            <LabelForm margen_abajo='0'>{this.state.labelOficial}</LabelForm>
                          </ContainerCol>
                        </Row>
                      
                    </ContainerCol>
                    <ContainerCol className='col-sm-6' margen_abajo='0'>
                      <Row>
                        <ContainerCol className='col-md-2'>
                          <LabelForm margen_abajo='0'>Cliente:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-md-10' >
                          <LabelForm margen_abajo='0'>{this.state.labelCliente}</LabelForm>
                        </ContainerCol>
                      </Row>
                      <Row>
                        <ContainerCol className='col-md-2'>
                          <LabelForm margen_abajo='0'>Cupo: </LabelForm>    
                        </ContainerCol>
                        <ContainerCol className='col-md-10' >
                          <LabelForm margen_abajo='0'>{this.state.labelCupo}</LabelForm>
                        </ContainerCol>
                      </Row>
                    </ContainerCol>
                  
                  </Row>

                  {/*DATOS CABECERA GENERAL*/}
                  <Row margen_arriba='3' isInvisible={this.props.departamento==='002'?true:false}>
                      <ContainerCol className='col-sm-5' margen_abajo='0'>
                        <Row>
                          <ContainerCol className='col-md-3'>
                            <LabelForm margen_abajo='0'>Vendedor: </LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-9' >
                            <LabelForm margen_abajo='0'>{this.state.labelVendedor}</LabelForm>
                          </ContainerCol>
                        </Row>
                        <Row>
                          <ContainerCol className='col-md-3'>
                            <LabelForm margen_abajo='0'>Cliente:</LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-9' >
                            <LabelForm margen_abajo='0'>{this.state.labelCliente}</LabelForm>
                          </ContainerCol>
                        </Row>                        
                        <Row>
                          <ContainerCol className='col-md-3'>
                            <LabelForm margen_abajo='0'>Dirección: </LabelForm>    
                          </ContainerCol>
                          <ContainerCol className='col-md-9' >
                            <ReactSelect options={ this.state.direccion_opt } value={this.state.direccion_sel} func_onChange={(value)=>{this.setState({direccion_sel: value})}}/>
                          </ContainerCol>
                        </Row>
                        <Row>
                          <ContainerCol className='col-md-3'>
                            <LabelForm margen_abajo='0'>Cupo: </LabelForm>    
                          </ContainerCol>
                          <ContainerCol className='col-md-9' >
                            <LabelForm margen_abajo='0'>{this.state.labelCupo}</LabelForm>
                          </ContainerCol>
                        </Row>  
                        <Row>
                          <ContainerCol className='col-md-3'>
                            <LabelForm margen_abajo='0'>Of.Crdto: </LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-9' >
                            <LabelForm margen_abajo='0'>{this.state.labelOficial}</LabelForm>
                          </ContainerCol>
                        </Row>                      
                      </ContainerCol>
                      <ContainerCol className='col-sm-7' margen_abajo='0'>
                        <Row>
                          <ContainerCol className='col-md-4'>
                            <LabelForm margen_abajo='0'>Fec. Pedido: </LabelForm>    
                          </ContainerCol>
                          <ContainerCol className='col-md-8' >
                            <LabelForm margen_abajo='0'>{this.state.labelFechaPedido}</LabelForm>
                          </ContainerCol>
                        </Row>
                        <Row>
                          <ContainerCol className='col-md-4'>
                            <LabelForm margen_abajo='0'>Fec. Ing. Sistema: </LabelForm>    
                          </ContainerCol>
                          <ContainerCol className='col-md-8' >
                            <LabelForm margen_abajo='0'>{this.state.labelRecDeporpas}</LabelForm>
                          </ContainerCol>
                        </Row>
                        <Row>
                          <ContainerCol className='col-md-4'>
                            <LabelForm margen_abajo='0'>Vencido: </LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-2' align='RIGHT'>
                            <LabelForm margen_abajo='0'>{this.state.labelVencidoValor}</LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-4'>
                            <LabelForm margen_abajo='0'>{`Más Vdo.: ${this.state.labelFechaVencida}`}</LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-1 '>
                            <BotonLink type="button" onClick={()=>{this.detalleSubModal('VENCIDO')}}>Detalles</BotonLink>
                          </ContainerCol>
                        </Row>
                        <Row>
                          <ContainerCol className='col-md-4'>
                            <LabelForm margen_abajo='0'>Por Vencer:</LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-2' align='RIGHT'>
                            <LabelForm  margen_abajo='1'>{`${this.state.labelPorVencerValor}`}</LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-4'>
                            <LabelForm margen_abajo='0'>{`Ult. Vto.: ${this.state.labelFechaPorVencer}`}</LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-1'>
                            <BotonLink type="button" onClick={()=>{this.detalleSubModal('PORVENCER')}}>Detalles</BotonLink>
                          </ContainerCol>
                        </Row>
                        <Row>
                          <ContainerCol className='col-md-4'>
                            <LabelForm margen_abajo='0'>Che. PostFechado: </LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-2' align='RIGHT'>
                            <LabelForm margen_abajo='0'>{this.state.labelValorChPost}</LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-5'>
                            <LabelForm margen_abajo='0'>Ult. Vto.: {this.state.labelFechaPostCh}</LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-1 col-md-pull-1'>
                            <BotonLink type="button" onClick={()=>{this.detalleSubModal('CHEPOST')}}>Detalles</BotonLink>
                          </ContainerCol>
                        </Row>
                        <Row>
                          <ContainerCol className='col-md-4'>
                            <LabelForm margen_abajo='0'>Nota de Crédito: </LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-2' align='RIGHT'>
                            <LabelForm margen_abajo='0'>{this.state.labelCredito}</LabelForm>
                          </ContainerCol>
                          <ContainerCol className='col-md-1 ' align='LEFT'>
                            <BotonLink margen_izq='0' margen_der='0' type="button" onClick={()=>{this.detalleSubModal('CREDITO')}}>Detalles</BotonLink>
                          </ContainerCol>

                          <ContainerCol className='col-md-3' align='RIGHT'>
                            <LabelFormUnique margen_izq='5' margen_der='5'>Ult. Comp.:</LabelFormUnique>                          
                          </ContainerCol>
                          <ContainerCol className='col-md-1'>
                            <BotonLink type="button" onClick={()=>{this.detalleSubModal('ULTIMAS COMPRAS')}}>Detalles</BotonLink>                        
                          </ContainerCol> 
                        </Row>                    
                      </ContainerCol>                 
                    </Row>                     

                  {/* CONTROLES PARA OFICIAL (Controles para dejar nota a comercial) */}
                  <Fieldset>
                    <Legend>Derivación por modificación:</Legend>
                    <Row>
                      <ContainerCol className='col-md-12'>
                        <Row>
                          <ContainerCol className='col-md-6'>
                            <Row>
                              <ContainerCol className='col-md-12'>
                                <LabelForm>Notas para Comercial:</LabelForm>
                                <TextArea altura={50} autoComplete='off' name='obsOficial' value={this.state.obsOficial} disabled={this.state.cargo === '004'?false:true}  onChange={this.handleInputChange} maxLength='70' mayusculas='true'/>  
                              </ContainerCol>
                            </Row>
                            <Row>
                              <ContainerCol className='col-md-2'>
                                <LabelForm>Cupo Máximo:</LabelForm>
                              </ContainerCol>
                              <ContainerCol className='col-md-6'>
                                <InputText autoComplete='off' name='cupoMaximoMod' type='number' value={this.state.cupoMaximoMod} disabled={this.state.cargo === '004'?false:true} onChange={this.handleInputChange}/>  
                              </ContainerCol>

                              {/* BOTONES DE REDIRECCION PARA OFICIAL */}
                              <ContainerCol className='col-md-2' isInvisible={!this.state.derivacionActive}>
                                <button type='button' className='btn btn-primary btn-sm' onClick={this.derivacionProcess}><i className='fa fa-reply-all fa-lg'/> Derivar</button>
                              </ContainerCol>

                              {/* BOTONES DE REDIRECCION PARA COMERCIAL */}
                              <ContainerCol className='col-md-2' isInvisible={this.props.departamento===this.state.areaEditPedido?false:true}>
                                <button type='button' className='btn btn-primary btn-sm' onClick={this.retornoProcess}><i className='fa fa-share fa-lg'/> Retorno</button>
                              </ContainerCol>
                            </Row>
                          </ContainerCol>

                          <ContainerCol className='col-md-6'>
                            <LabelForm>Notas de Comercial:</LabelForm>
                            <TextArea altura={85} autoComplete='off' name='obsComercial' value={this.state.obsComercial} disabled={this.props.departamento!=='002'?true:false}  onChange={this.handleInputChange} maxLength='100' mayusculas='true'/>
                          </ContainerCol>
                        </Row>
                      </ContainerCol>
                    </Row>
                  </Fieldset>

                  {/* CAJA DE APROBACION OFICIAL */}
                  <Row margen_arriba={5} isInvisible={this.props.departamento==='002'?true:false}>                    
                    <ContainerCol className='col-md-1'>
                      <LabelForm>{'Obs. Oficial'}:</LabelForm> 
                    </ContainerCol>
                    <ContainerCol className='col-md-11'>
                      <InputText autoComplete='off' name='obsOficialAprobacion' value={this.state.obsOficialAprobacion} disabled={this.state.cargo === '004'?false:true} onChange={this.handleInputChange} maxLength='70' mayusculas='true'/>  
                    </ContainerCol>
                  </Row>

                  {/* Observacion de Aprobacion para Jefe de Credito */}
                  <Row margen_arriba={5} isInvisible={this.state.cargo==='003' && this.props.departamento!=='002'?false:true}>
                    <ContainerCol className='col-md-12'>
                      <Row>
                        <ContainerCol className='col-md-1'>
                          <LabelForm>Obs. Jefe Crédito:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-md-11'>
                          <InputText autoComplete='off' name='obsJefeCredito' value={this.state.obsJefeCredito} disabled={this.state.cargo === '003'?false:true}  onChange={this.handleInputChange} maxLength='70' mayusculas='true'/>  
                        </ContainerCol>
                      </Row>
                    </ContainerCol>
                  </Row>

                  {/*CONTROLES DE ADICION*/}
                  <Row isInvisible={this.props.departamento===this.state.areaEditPedido?false:true}> 
                    <ContainerCol className='col-sm-5'>
                      <LabelForm>Artículo:</LabelForm>                
                      <SelectArticulo tipoArticulos='P' value={this.state.articulo_sel} func_onChange={(value)=>{this.setState({articulo_sel: value})}}/>
                    </ContainerCol>
                    <ContainerCol className='col-sm-2'>
                      <LabelForm>Cantidad:</LabelForm>
                      <div className='input-group'>
                        <InputText autoComplete='off' name='cantidadArt' value={this.state.cantidadArt===undefined?'':this.state.cantidadArt}  placeholder='Cant.' onChange={this.handleCantidad} maxLength='4'/>
                        <span className='input-group-btn'>
                          <ButtonUnion type='button' className='btn btn-success btn-sm' onClick={this.addArticulo}><i className='fa fa-plus'></i></ButtonUnion>                
                        </span>
                      </div>                    
                    </ContainerCol>
                    {/* <ContainerCol className='col-sm-5'>
                      <LabelForm>Observación:</LabelForm>
                      <InputText autoComplete='off' name='observacion' value={this.state.observacion} onChange={this.handleInputChange} maxLength='70' mayusculas='true'/>
                    </ContainerCol> */}
                  </Row>        
                  
                  {/*GRID + BOTONES*/}
                  <Row>
                    <ContainerCol className='col-md-11'>                    
                      <AgGridRender altura='250px' data={this.state.dataModal} columnas={this.state.columnDefsModal}
                        gridOptions={this.gridOptionsModal} onGridReady={this.onGridReadyModal}/>
                    </ContainerCol>

                    <ContainerCol className='col-md-1' margen_arriba='10' isInvisible={this.props.departamento!=='002' && (this.state.cargo === '004' || this.state.cargo === '003')?false:true}>
                      <Tooltip placement='right' overlay='Aprobar pedido'>
                        <ContainerCol className='btn-group pull-right'>
                          <button type='button' disabled={this.detectionChanges()===true?true:false} className='btn btn-success btn-sm' onClick={this.aprobacionPedidos}><i className="fa fa-check-circle-o fa-lg"/></button>
                        </ContainerCol>
                      </Tooltip>                                         
                    </ContainerCol>

                    <ContainerCol className='col-md-1' margen_arriba='5' isInvisible={this.props.departamento!=='002' && (this.state.cargo === '003')?false:true}>
                      <Tooltip placement='right' overlay='Rechazar pedido'>
                        <ContainerCol className='btn-group pull-right'>
                          <button type='button' disabled={this.detectionChanges()===true?true:false} className='btn btn-danger btn-sm' onClick={this.rechazarPedidos}><i className="fa fa-times-circle-o fa-lg"/></button>
                        </ContainerCol>
                      </Tooltip>                                         
                    </ContainerCol>

                    <ContainerCol className='col-md-1' margen_arriba='5' isInvisible={this.state.areaEditPedido === this.props.departamento?false:true}>
                      <Tooltip placement='right' overlay='Guardar pedido'>
                        <ContainerCol className='btn-group pull-right' >
                          <button type='button'className='btn btn-primary btn-sm' onClick={this.guardarDetPedido}><i className="fa fa-floppy-o fa-lg"/></button>
                        </ContainerCol>
                      </Tooltip> 
                    </ContainerCol>

                    <ContainerCol className='col-md-1' margen_arriba='5' isInvisible={this.state.areaEditPedido === this.props.departamento?false:true}>
                      <Tooltip placement='right' overlay='Volver a añadir al pedido'>
                        <ContainerCol className='btn-group pull-right' >
                          <button type='button'className='btn btn-warning btn-sm' onClick={this.revivirPedido}><i className="fa fa-arrow-circle-left fa-lg"/></button>
                        </ContainerCol>
                      </Tooltip> 
                    </ContainerCol>

                    <ContainerCol className='col-md-1' isInvisible={this.state.cargo === '004' || this.state.cargo === '003'?false:true} margen_arriba='5'>
                      <Tooltip placement='right' overlay='Historial aprobaciones/rechazos del pedido'>
                        <ContainerCol className='btn-group pull-right' >
                          <button type='button'className='btn btn-default btn-sm' onClick={this.historialAprobaciones}><i className="fa fa-history fa-lg"/></button>
                        </ContainerCol>
                      </Tooltip> 
                    </ContainerCol>
                  </Row>
                  
                  {/*LEYENDA SOBRE COLORES   isInvisible={this.props.departamento===this.state.areaEditPedido?false:true}*/}
                  <Row>
                    <ContainerCol className='col-md-6'>
                      <Row>
                        <ContainerCol className='col-md-4'>
                          <LabelCabecera color='#ff7057'><i className="fa fa-square" aria-hidden="true"></i>{'  '}<LabelForm margen_arriba='3'>{' Eliminado'}</LabelForm></LabelCabecera>
                        </ContainerCol>

                        <ContainerCol className='col-md-4'>
                          <LabelCabecera color='#ffc67f'><i className="fa fa-square" aria-hidden="true"></i>{'  '}<LabelForm margen_arriba='3'> Modificado</LabelForm></LabelCabecera>
                        </ContainerCol>

                        <ContainerCol className='col-md-4'>
                          <LabelCabecera color='#4aeccf'><i className="fa fa-square" aria-hidden="true"></i>{'  '}<LabelForm margen_arriba='3'> Añadido</LabelForm></LabelCabecera>
                        </ContainerCol>
                      </Row>
                    </ContainerCol>

                    <ContainerCol className='col-md-6'>
                      <Row>
                        <ContainerCol className='col-md-2'>
                          <LabelCabecera color='green'>SubTotal: {this.state.subTotal}</LabelCabecera>
                        </ContainerCol>

                        <ContainerCol className='col-md-2'>
                          <LabelCabecera>Descuento: {this.state.descuento}</LabelCabecera>
                        </ContainerCol>

                        <ContainerCol className='col-md-2'>
                          <LabelCabecera margen_abajo={0}>Neto: {this.state.neto}</LabelCabecera>
                        </ContainerCol>

                        <ContainerCol className='col-md-2'>
                          <LabelCabecera margen_abajo={0}>Iva: {<br/>}{this.state.iva}</LabelCabecera>
                        </ContainerCol>

                        <ContainerCol className='col-md-2'>
                          <LabelCabecera>Total: {this.state.totalFactura}</LabelCabecera>
                        </ContainerCol>
                      </Row>
                    </ContainerCol>
                  </Row>                
                </ContenedorModal>
              </CuerpoForm>
            </ModalResponsive>                       
          
            <ModalResponsive open={this.state.isVisibleDetalleVencido} onClose={()=>{this.setState({isVisibleDetalleVencido: false})}}>
              <HeaderForm>
                  <TituloForm>{`No. Pedido: ${this.state.labelPedido} - ${this.state.labelSubModal}`}</TituloForm>
              </HeaderForm>
              <CuerpoForm>
                <ContenedorSubModal>
                  <Row>
                    <ContainerCol className='col-md-12'>
                      <AgGridRender altura='250px' data={this.state.dataSubModal} columnas={this.state.columnDefsSubModal}
                      gridOptions={this.gridOptionsSubModal} onGridReady={this.onGridReadySubModal}/>
                    </ContainerCol>
                  </Row>
                  <Row>
                    <ContainerCol className='col-md-8'>
                      <LabelForm>{this.state.labelSubModalOP}: {this.state.labelTotalSubModal}</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-md-4' isInvisible={this.state.labelSubModal==='ULTIMAS COMPRAS'?false:true}>
                      <ContainerCol className='btn-group pull-right'>
                        <button className='btn btn-light btn-sm' onClick={this.getReporteFactura}><i className='fa fa-print fa-lg'></i> Imprimir Fac.</button>
                      </ContainerCol>
                    </ContainerCol>
                  </Row>
                </ContenedorSubModal>
              </CuerpoForm>
            </ModalResponsive>
          
            <ModalResponsive open={this.state.isVisibleHistorialAprobacion} onClose={()=>{this.setState({isVisibleHistorialAprobacion: false})}}>
              <HeaderForm>
                <TituloForm>{`No. Pedido: ${this.state.labelPedido} - Historial del pedido`}</TituloForm>
              </HeaderForm>
              <CuerpoForm>
                <ContenedorHistorial>
                  <Row>
                    <ContainerCol className='col-md-12'>
                      <AgGridRender altura='250px' data={this.state.dataHis} columnas={this.state.columnDefsHis}
                      gridOptions={this.gridOptionsHistorial} onGridReady={this.onGridReadyHistorial}/>
                    </ContainerCol>
                  </Row>
                </ContenedorHistorial>
              </CuerpoForm>
            </ModalResponsive>

            <ModalResponsive open={this.state.isVisibleModalAnular} onClose={()=>{this.setState({isVisibleModalAnular:false})}}>
              <Container>
                <Row>
                  <div className='col-md-12'><LabelForm>Motivo Anulación:</LabelForm></div>
                </Row>
                <Row>
                  <div className='col-md-12'>
                    <TextArea maxLength='70' rows='5' cols='53' name='motivoAnulacion' value={this.state.motivoAnulacion} onChange={this.handleInputChange}/>
                  </div>
                </Row>
                <Row>
                  <div className='col-md-12'>
                    <div className="btn-group pull-right">
                      <button type='button' className='btn btn-danger btn-sm' onClick={this.anularPedido}><i className='fa fa-window-close fa-lg'/> Anular</button>
                    </div>
                  </div>                  
                </Row>
              </Container>
            </ModalResponsive>
          </div>
      );
  }
}

const mapStateToProps = state =>{
  return {  permiso: state.sesion.valoresSesionForm.Permiso,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            isVisibleLoading: state.ui.isVisibleLoading, 
            cargo: state.sesion.valoresSesionForm.Cargo,
            usuario: state.sesion.valoresSesionForm.Usuario,
            departamento: state.sesion.valoresSesionForm.Departamento 
  };
};

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ generar_LogAuditoriaIngresoForm, 
                              generar_LogAuditoriaSalidaForm,
                              cambiar_VisualizacionLoading
                             }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormVen01);